import { CargoCompanyListItem } from "../../../../../../common/services/cargo-company/cargo-company/list/cargo-company-list";
import { CargoCompanyDispatchMultiListItem } from "../../../../../../common/services/cargo-company/dispatch/multi-list/cargo-company-dispatch-multi-list";
import PassengerAddParams from "../../../../../../common/services/passenger/add/passenger-add-params";
import PassengerDispatchSelectOption from "../../../common/types/passenger-dispatch-select-option";
import passengerAddFactory from "../../common/passenger-add.factory";
import PassengerAddByRailyCargoCompanySelectOption from "./types/passenger-add-by-raily-cargo-company-select-option";
import PassengerAddByRailyFormData from "./types/passenger-add-by-raily-form-data";

const createAddPassengerParams = (
  formData: PassengerAddByRailyFormData,
): PassengerAddParams => {
  const addresses = passengerAddFactory.createAddPassengerRequestAddresses(
    formData.addresses,
  );
  const dispatchIds = passengerAddFactory.createAddPassengerRequestDispatchIds(
    formData.dispatches!,
  );

  const params: PassengerAddParams = {
    firstName: formData.firstName.trim(),
    lastName: formData.lastName.trim(),
    mobilePrimaryPrefix: formData.mobile.dialingCode || undefined,
    mobilePrimary: formData.mobile.number || undefined,
    mobileSecondaryPrefix: formData.alternativeMobile.dialingCode
      ? formData.alternativeMobile.dialingCode
      : undefined,
    mobileSecondary: formData.alternativeMobile.number
      ? formData.alternativeMobile.number
      : undefined,
    email: formData.email.trim(),
    username: formData.username.trim(),
    password: formData.password,
    passenger: {
      addresses: addresses,
      dispatchIds: dispatchIds,
    },
  };

  return params;
};

const createCargoCompanySelectOption = (
  responseCargoCompany: CargoCompanyListItem,
): PassengerAddByRailyCargoCompanySelectOption => {
  return {
    label: responseCargoCompany.displayName,
    value: {
      uuid: responseCargoCompany.uuid,
      displayName: responseCargoCompany.displayName,
    },
  };
};

const createCargoCompanySelectOptions = (
  responseCargoCompanies: CargoCompanyListItem[],
): PassengerAddByRailyCargoCompanySelectOption[] => {
  return responseCargoCompanies.map(createCargoCompanySelectOption);
};

const createDispatchSelectOption = (
  dispatch: CargoCompanyDispatchMultiListItem,
  company: CargoCompanyListItem,
): PassengerDispatchSelectOption => {
  return {
    label: `${dispatch.displayName} (${company.displayName})`,
    value: {
      uuid: dispatch.uuid,
      displayName: dispatch.displayName,
      addressString: dispatch.address,
      cargoCompanyId: dispatch.cargoCompanyId,
    },
  };
};

const createDispatchSelectOptions = (
  dispatches: CargoCompanyDispatchMultiListItem[],
  companies: CargoCompanyListItem[],
  allowedCompanyUuids?: string[],
): PassengerDispatchSelectOption[] => {
  return dispatches
    .filter(
      (dispatch) =>
        !allowedCompanyUuids ||
        allowedCompanyUuids.includes(dispatch.cargoCompanyId),
    )
    .map((dispatch) => {
      const company = companies.find(
        (company) => company.uuid === dispatch.cargoCompanyId,
      );
      return createDispatchSelectOption(dispatch, company!);
    });
};

const passengerAddByRailyFactory = {
  createAddPassengerParams,
  createCargoCompanySelectOptions,
  createDispatchSelectOptions,
};

export default passengerAddByRailyFactory;
